import React from 'react';

import { ReactComponent as Spinner } from 'assets/icons/spinner.svg';

import { LoaderWrapper } from './elements';

export function Loader(props) {
  const { title, children, ...rest } = props;
  return (
    <LoaderWrapper {...rest}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Spinner style={{ marginBottom: 28, fill: props.fill }} />
        {children ? <div>{children}</div> : <p>Loading {title}...</p>}
      </div>
    </LoaderWrapper>
  );
}

export default Loader;
